import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaTag } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Loading,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
} from '~/components';

import { GraphArea, LoadArea, ToogleInfo } from './styles';

import Grafico from './Grafico';

import RelatorioVendaMensal from '~/@types/relatoriovendamensal';
import { Combo, Combos } from '../VendasDiarias/styles';
import { anoAtual } from '~/helpers/date';

const VendasMensais: React.FC = () => {
  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);

  //FILTROS
  const [ano, setAno] = useState(anoAtual());
  const [comboAnoVisibilidade, setComboAnoVisibilidade] = useState(false);

  // VENDAS MENSAIS
  const [vendasmensais, setVendasmensais] = useState<RelatorioVendaMensal[]>(
    [],
  );
  const [vendasMensaisVisibilidade, setGraficoVisibilidade] = useState(true);

  // MODULO (VENDAS MENSAIS)
  const filtrarMesesPorModulo = (
    pModuloGrafico: string,
    pGrafico: RelatorioVendaMensal[],
  ) => {
    const meses: RelatorioVendaMensal[] = [];

    let c;
    for (c in pGrafico) {
      const mes = pGrafico[c];
      if (`${mes.modulo}` === pModuloGrafico) {
        meses.push(mes);
      }
    }

    return meses;
  };
  const gerarRelatorioGraficoCSV = () => {
    let data: string[] = [];

    data.push('ANO;MES;PEDIDOS;TICKETMEDIO;PRODUTOS;FRETE;DESCONTO;TOTAL');

    const meses = filtrarMesesPorModulo(ano, vendasmensais);

    let c;
    for (c in meses) {
      const mes = meses[c];
      data.push(
        `${mes.ano};${mes.nome};${mes.pedidos};${mes.ticketmedio};${mes.produtos};${mes.frete};${mes.desconto};${mes.total}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, 'VENDAS MENSAIS');
  };

  const gerarRelatoriosGraficoPDF = () => {
    const cabecalho = [
      'ANO',
      'MES',
      'PEDIDOS',
      'TICKET MÉDIO',
      'PRODUTOS',
      'FRETE',
      'DESCONTO',
      'TOTAL',
    ];

    const data: string[][] = [];

    const meses = filtrarMesesPorModulo(ano, vendasmensais);

    let c;
    for (c in meses) {
      const mes = meses[c];

      const linha: string[] = [];

      linha.push(`${mes.ano}`);
      linha.push(`${mes.nome}`);
      linha.push(`${mes.pedidos}`);
      linha.push(`${mes.ticketmedio}`);
      linha.push(`${mes.produtos}`);
      linha.push(`${mes.frete}`);
      linha.push(`${mes.desconto}`);
      linha.push(`${mes.total}`);

      data.push(linha);
    }

    exportPdf(cabecalho, data, 'VENDAS MENSAIS');
  };

  const exibicaoTotalPedidos = (pTotalPedidos: number) => {
    if (!pTotalPedidos) return 'Nenhum pedido';
    if (pTotalPedidos === 1) {
      return 'Um pedido';
    }
    return `${pTotalPedidos} pedidos`;
  };

  useEffect(() => {
    const fetchVendasMensais = async () => {
      try {
        setInLoad(true);
        setVendasmensais([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_por_mes';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setVendasmensais(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    fetchVendasMensais();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Vendas Mensais"
            subtitle="Confira as métricas de vendas distribuídas mensalmente"
            icon={
              <>
                <FaCalendarAlt size={32} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {vendasmensais.length ? (
            <GraphArea>
              <header>
                <i>
                  <FaCalendarAlt size={22} color={colors.IC1} />
                </i>
                <p>
                  <h1>Vendas mensais</h1>
                  <h2>
                    Confira as métricas de vendas distribuídas mensalmente
                  </h2>
                </p>

                <div>
                  <button
                    className="excel"
                    onClick={gerarRelatorioGraficoCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatoriosGraficoPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </div>
              </header>

              <Combos>
                <Combo>
                  <div
                    onClick={() =>
                      setComboAnoVisibilidade(!comboAnoVisibilidade)
                    }
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>{ano}</span>
                    <i>
                      {comboAnoVisibilidade ? (
                        <IoMdArrowDropup size={22} color={colors.IC1} />
                      ) : (
                        <IoMdArrowDropdown size={22} color={colors.IC1} />
                      )}
                    </i>
                  </div>
                  {comboAnoVisibilidade ? (
                    <ul>
                      <li>
                        <button
                          onClick={() => {
                            setAno('2024');
                            setComboAnoVisibilidade(false);
                          }}
                        >
                          2024
                        </button>
                        <button
                          onClick={() => {
                            setAno('2025');
                            setComboAnoVisibilidade(false);
                          }}
                        >
                          2025
                        </button>
                        <button
                          onClick={() => {
                            setAno('2026');
                            setComboAnoVisibilidade(false);
                          }}
                        >
                          2026
                        </button>
                      </li>
                    </ul>
                  ) : null}
                </Combo>
              </Combos>

              <main>
                <div>
                  <Grafico
                    vendasMensais={filtrarMesesPorModulo(ano, vendasmensais)}
                  />
                </div>
              </main>

              <footer>
                {vendasMensaisVisibilidade ? (
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="Periodo" />
                      <GridHeadItem title="Pedidos" width={150} />
                      <GridHeadItem title="Ticket Médido" width={150} />
                      <GridHeadItem title="Produtos" width={150} />
                      <GridHeadItem title="Frete" width={150} />
                      <GridHeadItem title="Desconto" width={150} />
                      <GridHeadItem title="Total" width={150} />
                    </GridLine>

                    {filtrarMesesPorModulo(ano, vendasmensais).map(
                      (mes, key) => (
                        <GridLine key={mes.periodo}>
                          <GridItem>
                            {mes.nome} de {mes.ano}
                          </GridItem>
                          <GridItem width={150}>
                            {exibicaoTotalPedidos(mes.pedidos)}
                          </GridItem>
                          <GridItem width={150}>
                            {mes.ticketmedio.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {mes.produtos.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {mes.frete.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {mes.desconto.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {mes.total.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                        </GridLine>
                      ),
                    )}
                  </Grid>
                ) : null}
                <ToogleInfo
                  onClick={() =>
                    setGraficoVisibilidade(!vendasMensaisVisibilidade)
                  }
                >
                  {vendasMensaisVisibilidade ? (
                    <IoMdArrowDropup size={32} color={colors.IC1} />
                  ) : (
                    <IoMdArrowDropdown size={32} color={colors.IC1} />
                  )}
                </ToogleInfo>
              </footer>
            </GraphArea>
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default VendasMensais;
